import { Time } from "types/v2/common/Time";
import getUserLocale from "pagesPc/utils/getUserLocale";

export const convertSecondsToMinutesHoursDays = (seconds: number): Time => {
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  return {
    minutes: minutes % 60,
    hours: hours % 24,
    days: days,
  };
};

export const passedSeconds = (timeStampString: string): number => {
  const targetDate = new Date(timeStampString);
  const currentDate = new Date();
  const millisecondsDifference = currentDate.getTime() - targetDate.getTime();
  return Math.floor(millisecondsDifference / 1000);
};

export const timeStatusGenerator = (timeObject: Time) => {
  const formatUnit = (value: number, unit: string) =>
    value > 1 ? `${value} ${unit}` : value === 1 ? `یک ${unit}` : "";

  const { days, hours, minutes } = timeObject;

  if (minutes < 1 && !hours && !days) {
    return "لحظاتی";
  } else if (minutes < 60 && !hours && !days) {
    return formatUnit(minutes, "دقیقه");
  } else if (hours <= 2 && !days && minutes >= 1) {
    const formattedHours = formatUnit(hours, "ساعت");
    const formattedMinutes = formatUnit(minutes % 60, "دقیقه");
    return `${formattedHours} و ${formattedMinutes}`.trim();
  } else if (hours > 2 && !days) {
    const formattedHours = formatUnit(hours, "ساعت");
    return `${formattedHours}`.trim();
  } else if (days >= 1 && !hours) {
    const formattedDays = formatUnit(days, "روز");
    return `${formattedDays}`.trim();
  } else if (days >= 1) {
    const formattedDays = formatUnit(days, "روز");
    const formattedHours = formatUnit(hours, "ساعت");
    return `${formattedDays} و ${formattedHours}`.trim();
  } else {
    const formattedHours = formatUnit(hours, "ساعت");
    return `${formattedHours}`.trim();
  }
};

const locale = getUserLocale();
const dateOptions: Intl.DateTimeFormatOptions = {
  year: "numeric",
  month: "numeric",
  day: "numeric",
};

export const timeStampToPersianDate = (timeStamp: string) => {
  const date = new Date(timeStamp);
  if (isNaN(date.getTime())) {
    return "";
  }
  try {
    return date.toLocaleDateString(locale, dateOptions);
  } catch (error) {
    return "";
  }
};

export const addMonths = (date: Date, months: number): Date => {
  // Create a new Date object to avoid mutating the original
  const newDate = new Date(date);

  // Calculate the new month and year
  let newMonth = newDate.getMonth() + months;
  let yearAdjustment = Math.floor(newMonth / 12);

  // Normalize the month to ensure it's between 0-11
  newMonth = newMonth % 12;
  if (newMonth < 0) {
    newMonth += 12;
    yearAdjustment--;
  }

  // Set the new month and adjust the year
  newDate.setMonth(newMonth);
  newDate.setFullYear(newDate.getFullYear() + yearAdjustment);

  return newDate;
};
